import { render, staticRenderFns } from "./Ips.vue?vue&type=template&id=48fee9fc&"
import script from "./Ips.vue?vue&type=script&lang=js&"
export * from "./Ips.vue?vue&type=script&lang=js&"
import style0 from "./Ips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports